<template>
	<div class="leftres">
		<div>
			<div :class="showorhide ? 'inputtop' : 'inputtops'">
				<div style="display: inline-block;" v-for="(item, index) of formdata" :key="index">
					<Commondropdownlist ref="U8DeRefs" :options="item.options" :minrigth="item.minrigth"
						:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
						:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width" :event="item.event"
						@level1Chage="level1Chage" @level2Chage="level2Chage" @level3Chage="level3Chage">
					</Commondropdownlist>
				</div>
				<div :class="showorhide ? 'Btngroups' : 'Btngroup'">
					<CommonBtngroup :chackbox="false" ref="btngroup" :show="showorhide" @showclick="showclick"
						@hide="hide" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;"></div>
			</div>

			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<U8DeliveryOrderReporttable @StockExport="StockExport" @onRowClick="onRowClick" :tableData="tableData"
					:total="total" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</U8DeliveryOrderReporttable>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from "../../../components/common-dropdownlist.vue";
	import CommonBtngroup from "../../../components/commongroup.vue";
	import Dialog from "../../../components/dialog.vue";
	import U8DeliveryOrderReporttable from "./components/U8DeliveryOrderReporttable.vue";
	import utils from "../../../common/utils";
	import {
		U8ReportU8RDReportList,
		HelperU8AccId,
		U8ReportU8RDReportExport,
		HelperU9Status,
	} from "@/api/home";

	import {
		GetHelperLevel1,
		GetHelperLevel2,
		GetHelperLevel3,
	} from "@/api/newsapi";
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			U8DeliveryOrderReporttable,
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: "",
						title: "账套号",
						fontSize: "14px",
						color: "#333333",
						placeholder: "全部",
						types: "",
						inputtype: "select",
						width: "210px",
						options: [],
					},
					{
						inputdata: "",
						title: "经销商",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "200px",
					},
					{
						inputdata: "",
						title: "出库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "",
						types: "",
						inputtype: "date",
					},
					{
						inputdata: "",
						title: "产品",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "200px",
					},
					{
						inputdata: "",
						title: "出库单号",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "200px",
					},
					{
						inputdata: "",
						title: "LEVEL1",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "220px",
						options: [],
						event: "level1Chage",
					},
					{
						inputdata: "",
						title: "LEVEL2",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "220px",
						options: [],
						event: "level2Chage",
					},
					{
						inputdata: "",
						title: "LEVEL3",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "220px",
						options: [],
						event: "level3Chage",
					},
					{
						inputdata: "",
						title: "产品批号",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "210px",
					},
					{
						inputdata: [],
						title: "状态",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "selectMultiple",
						width: "220px",
						options: [],
					},
				],
				fromdatalist: [],
				from: {
					cAccId: "",
					Customer: "",
					cCode: "",
					dDate1: "",
					dDate2: "",
					Inventory: "",
					Batch: "",
					Status: "",
				},
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
				},
			};
		},
		computed: {
			Currentmonth() {
				let date = new Date();
				let Currentmonth = `${date.getFullYear()}-${date.getMonth() + 1}-1`; //获取本月第一天
				return Currentmonth;
			},
			Currentday() {
				let date = new Date();
				let Currentday = `${date.getFullYear()}-${date.getMonth() +
        1}-${date.getDate()}`; //获取当前日期
				return Currentday;
			},
		},
		mounted() {
			this.$refs.U8DeRefs[2].startTime = this.$utils.getFYearDate();
			this.$message.warning("请填写搜索条件！");
			this.HelperU8AccId();
			this.HelperU9Status();
			this.getHelperLevel1();
		},
		methods: {
			level1Chage(e) {
				this.from.LEVEL1 = e.modelvalue;
				this.getHelperLevel2();
			},
			level2Chage(e) {
				this.from.LEVEL2 = e.modelvalue;
				this.getHelperLevel3();
			},
			level3Chage(e) {
				this.from.LEVEL3 = e.modelvalue;
			},
			//获取l1数据
			async getHelperLevel1() {
				let {
					code,
					data
				} = await GetHelperLevel1({});
				if (code == 0) {
					this.formdata[5].options = [{
						key: "不限",
						value: "",
					}, ];
					this.formdata[6].options = [];
					this.formdata[7].options = [];
					data.map((item, index) => {
						this.formdata[5].options.push({
							key: item.value,
							value: item.key,
						});
					});
				}
			},
			//获取l2数据
			async getHelperLevel2() {
				let {
					code,
					data
				} = await GetHelperLevel2({
					LEVEL1: this.from.LEVEL1,
				});
				if (code == 0) {
					this.formdata[6].options = [];
					this.formdata[7].options = [];
					data.map((item, index) => {
						this.formdata[6].options.push({
							key: item.value,
							value: item.key,
						});
					});
				}
			},
			//获取l3数据
			async getHelperLevel3() {
				let {
					code,
					data
				} = await GetHelperLevel3({
					LEVEL1: this.from.LEVEL1,
					LEVEL2: this.from.LEVEL2,
				});
				if (code == 0) {
					this.formdata[7].options = [];
					data.map((item, index) => {
						this.formdata[7].options.push({
							key: item.value,
							value: item.key,
						});
					});
				}
			},
			// //默认日期
			// days() {
			//   let date = new Date()
			//   let Currentmonth = `${date.getFullYear()}-${date.getMonth() + 1}-1`
			//   try {
			//     this.$refs.RDAUNSRefs[4].startTime = Currentmonth
			//     //console.log(this.$refs.RDAUNSRefs[4].startTime);
			//   } catch (error) {
			//   }

			// },

			// 列表
			async u8ReportU8RDReportList() {
				const loading = this.$loading({
					lock: true,
					text: "正在加载列表...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)",
				});
				let {
					data,
					code,
					message
				} = await U8ReportU8RDReportList({
					cAccId: this.from.cAccId || this.formdata[0].options[0].key,
					Customer: this.from.Customer,
					cCode: this.from.cCode,
					dDate1: this.from.dDate1,
					dDate2: this.from.dDate2,
					Inventory: this.from.Inventory,
					LEVEL1: this.from.LEVEL1,
					LEVEL2: this.from.LEVEL2,
					LEVEL3: this.from.LEVEL3,
					Batch: this.from.Batch,
					Status: this.from.Status,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				// //console.log(code, data.data)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
				loading.close();
			},
			async u8ReportU8RDReportExport() {
				const loading = this.$loading({
					lock: true,
					text: "正在导出...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)",
				});
				let resexprot = await U8ReportU8RDReportExport({
					cAccId: this.from.cAccId || this.formdata[0].options[0].key,
					Customer: this.from.Customer,
					cCode: this.from.cCode,
					dDate1: this.from.dDate1,
					dDate2: this.from.dDate2,
					Inventory: this.from.Inventory,
					LEVEL1: this.from.LEVEL1,
					LEVEL2: this.from.LEVEL2,
					LEVEL3: this.from.LEVEL3,
					Batch: this.from.Batch,
					Status: this.from.Status,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				if (resexprot) {
					let date = new Date();
					let str = `${date.getFullYear()}-${date.getMonth() +
          1}-${date.getDate()}-${date.getTime()}`;
					utils.downloadFile(resexprot, `U8_U9出库单报表${str}`, "xlsx");
					loading.close();
				} else {
					// 返回json
					this.$message.warning("导出失败");
					loading.close();
				}
				loading.close();
			},
			StockExport() {
				this.u8ReportU8RDReportExport();
			},
			// 获取账套号下拉
			async HelperU8AccId() {
				let {
					code,
					data
				} = await HelperU8AccId({});
				if (code == 0) {
					try {
						this.formdata[0].options = [];
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text,
							};
							this.formdata[0].options.push(obj);
						});
						this.$refs.U8DeRefs[0].modelvalue = this.formdata[0].options[0].key;
						//this.u8ReportU8RDReportList()
					} catch (error) {}
				}
			},
			// 获取状态下拉
			async HelperU9Status() {
				let {
					code,
					data
				} = await HelperU9Status({})
				if (code == 0) {
					try {
						this.formdata[9].options = []
						data.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text
							}
							this.formdata[9].options.push(obj)
						})
					} catch (error) {}
				}
			},
			reset() {
				this.$refs.U8DeRefs.map((item, index) => {
					if (index == 2 || index == 5 || index == 6) {
						item.startTime = "";
						item.endTime = "";
					} else if (index == 9) {
						item.modelvalue = []
					} else {
						item.modelvalue = "";
					}
				});
			},
			cancel() {
				this.dialogVisibles = false;
			},
			dialogOK() {
				this.dialogVisibles = false;
			},
			select() {
				for (let item of this.formdata) {
					this.fromdatalist.push(item.inputdata);
				}
				this.pageindex = 1;
				try {
					this.from.cAccId = this.$refs.U8DeRefs[0].modelvalue;
					this.from.Customer = this.$refs.U8DeRefs[1].modelvalue;
					this.from.cCode = this.$refs.U8DeRefs[4].modelvalue;
					this.from.dDate1 = this.$refs.U8DeRefs[2].startTime;
					this.from.dDate2 = this.$refs.U8DeRefs[2].endTime;
					this.from.Inventory = this.$refs.U8DeRefs[3].modelvalue;
					this.from.Batch = this.$refs.U8DeRefs[8].modelvalue;
					if (this.$refs.U8DeRefs[9].modelvalue) {
						this.from.Status = this.$refs.U8DeRefs[9].modelvalue.join(',')
					} else {
						this.from.Status = ''
					}
					this.u8ReportU8RDReportList();
				} catch (error) {
					this.u8ReportU8RDReportList();
				}
			},
			hide() {
				this.showorhide = false;
				//console.log("askdas", this.showorhide)
			},
			showclick() {
				this.showorhide = true;
			},
			onRowClick(val) {
				//console.log(val, 'val');
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex;
				this.u8ReportU8RDReportList();
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie;
				this.u8ReportU8RDReportList();
			},
		},
		watch: {
			showorhide(newVal) {
				if (newVal == true) {
					//  this.$refs.RDAUNSRefs[4].startTime = "2012-12-5"
					// this.days()
					// //console.log(newVal,'newVal');
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 100px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 300px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 95px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 40px;
	}
</style>